import styled from 'styled-components';

import { mediaTopBarVisible } from '@xing-com/layout-tokens';
import { SkeletonHeadline } from '@xing-com/skeleton';
import { scale320, scale390, space3XL, spaceXXL } from '@xing-com/tokens';

const SkeletonContainer = styled.div`
  margin-bottom: ${space3XL};
`;

const SkeletonPageHeaderContainer = styled.div`
  padding: ${spaceXXL} 0;

  @media ${mediaTopBarVisible} {
    display: flex;
    justify-content: start;
    padding: ${spaceXXL} 0;
  }
`;

const SkeletonPageHeaderHeadline = styled(SkeletonHeadline)`
  flex: 1;
  max-width: ${scale390};

  @media ${mediaTopBarVisible} {
    max-width: ${scale320};
  }
`;

export const Styled = {
  SkeletonContainer,
  SkeletonPageHeaderContainer,
  SkeletonPageHeaderHeadline,
};
